import myaxios from "../../components/Axios";

export const createCaseService = ({ data }) => myaxios.post(`/ajax/case`, data)
export const getSingleCaseService = ({ id, expand }) => myaxios.get(`/ajax/case/${id}?expand=${expand}`)
export const updateCaseService = ({ id, data }) => myaxios.put(`/ajax/case/${id}`, data)
export const deleteCaseService = ({ id }) => myaxios.delete(`/ajax/case/${id}`)
export const getCasePrepareService = () => myaxios.get(`/ajax/case/prepare`)
export const getCaseListService = ({ expand = "", filter = "", sort = "" }) => myaxios.get(`/ajax/case/`)